// @flow
import * as React from 'react'

type FeatureToggleProps = {
  active: boolean,
  children: React.Node,
  Otherwise?: React.Node
}

const FeatureToggle = ({ active, children, Otherwise = null }: FeatureToggleProps) => (active ? children : Otherwise)

export default FeatureToggle
